import {
  IconButton,
  Menu,
  MenuItem,
  Box,
  styled,
  TableCell,
  TableRow,
  Button,
  Grid,
  Typography,
  Paper,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import GppGoodIcon from '@mui/icons-material/GppGood';
import ShieldIcon from '@mui/icons-material/Shield';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import SearchIcon from '@mui/icons-material/Search';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';
import PieChart from './PieChart';
import { api } from '../../../api';
import { ZKDevice } from '../../../schema/zk_device';
import { Gate } from '../../../schema/gate';

const tableHead = [
  'ลำดับ',
  'รหัสอุปกรณ์',
  'IP Address',
  'ชื่ออุปกรณ์',
  'คำสั่งคงค้าง',
  'สถานะ'
  // ''
];

const ScanConnectionStatus = () => {
  const [devices, setDevices] = useState<ZKDevice[]>([]);
  const [filter, setFilter] = useState<string>("ALL");
  const [ipaddress, setIpaddress] = useState<string>("");
  const [deviceName, setDeviceName] = useState<string>("");
  

  useEffect(() => {
    api.get<ZKDevice[]>(`/bypass/zk_device_full`).then((res) => {
      const { data } = res;
      setDevices(data)
    });
  }, []);
  
  return (
    <>
      <Container>
        <PageHeader text="สถานะเชื่อมต่อเครื่องสแกน" />

        <Paper sx={{ p: 3, my: 3 }}>
          <Box display="flex" justifyContent="space-around">

         
            <CardContainer bgColor="#a8fffe" onClick={() => setFilter('ALL')}>
              <Typography variant="h5" my={2} >
                {devices.length}
              </Typography>
              <Typography>ประตูทั้งหมด</Typography>
            </CardContainer>
         


            <CardContainer bgColor="#a1ffb5" onClick={() => setFilter('Online')}>
              <Typography variant="h5" my={2}>
                {devices.filter((data) => data.device_status === '1').length}
              </Typography>
              <Typography>ออนไลน์</Typography>
            </CardContainer>
 
            
            <CardContainer bgColor="#ffa799" onClick={() => setFilter('Offline')}>
              <Typography variant="h5" my={2}>
                {devices.filter((data) => data.device_status === '0').length}
              </Typography>
              <Typography>ขาดการเชื่อมต่อ</Typography>
            </CardContainer>
           

            <CardContainer bgColor="#fdfd96" onClick={() => setFilter('Disabled')}>
              <Typography variant="h5" my={2}>
                {devices.filter((data) => data.device_status === '2').length}
              </Typography>
              <Typography>ปิดการใช้งาน</Typography>
            </CardContainer>
          </Box>
        </Paper>

        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="IP ADDRESS"
                  variant="outlined"
                  placeholder="IP ADDRESS"
                  name="IP_ADDRESS"
                  value={ipaddress}
                  onChange={(e) => setIpaddress(e.target.value)}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="ชื่ออุปกรณ์"
                  variant="outlined"
                  placeholder="ชื่ออุปกรณ์"
                  name="group_name"
                  value={deviceName}
                  onChange={(e) => setDeviceName(e.target.value)}
                  autoComplete="off"
                />
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth>
                  <InputLabel id="select-status-label">สถานะ</InputLabel>
                  <Select
                    labelId="select-status-label"
                    value={filter}
                    label="สถานะ"
                    name="status"
                    onChange={(e) => {
                      setFilter(e.target.value);
                    }}
                  >
                    <MenuItem value="ALL">ทั้งหมด</MenuItem>
                    <MenuItem value="Online">ออนไลน์</MenuItem>
                    <MenuItem value="Offline">ขาดการเชื่อมต่อ</MenuItem>
                    <MenuItem value="Disabled">ปิดการใช้งาน</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Paper sx={{ mt: 1 }}>
              <Table heads={tableHead} count={devices.length}>
              {devices.filter(data => {
                if(filter == "ALL"){
                  return true && (data.device_name.includes(deviceName)) && (data.device_ip_address.includes(ipaddress))
                }
                if(filter == "Online"){
                  return data.device_status === '1' && (data.device_name.includes(deviceName)) && (data.device_ip_address.includes(ipaddress))
                }
                if(filter == "Offline"){
                  return data.device_status === '0' && (data.device_name.includes(deviceName)) && (data.device_ip_address.includes(ipaddress))
                }
                if(filter == "Disabled"){
                return data.device_status === '2' && (data.device_name.includes(deviceName)) && (data.device_ip_address.includes(ipaddress))
                }
              }).map((item, index) => {
               
                    return <TableRow key={index}>
                    <TableCell align="center">{index+1}</TableCell>
                    <TableCell align="center">{item.device_id}</TableCell>
                    <TableCell align="center">{item.device_ip_address}</TableCell>
                    <TableCell align="center">{item.device_name}</TableCell>
                    <TableCell align="center">{item.command}</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color={
                          (item.device_status == "2" ? 'warning' : (item.device_status == "1" ? 'success' : 'error'))
                        }
                      >
                        {(item.device_status == "2" ? 'ปิดการใช้งาน' : (item.device_status == "1" ? 'ออนไลน์' : 'ขาดการเชื่อมต่อ'))}
                      </Button>
                    </TableCell>
                  </TableRow>
                  
})}
              </Table>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <PieChart
              data={[
                {
                  name: 'ออนไลน์',
                  value: devices.filter((data) => data.device_status === '1').length
                },
                {
                  name: 'ปิดการใช้งาน',
                  value: devices.filter((data) => data.device_status === '2').length
                },
                {
                  name: 'ขาดการเชื่อมต่อ',
                  value: devices.filter((data) => data.device_status === '0').length
                }
              ]}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ScanConnectionStatus;

const Container = styled('div')`
  padding: 24px;
`;

type CardContainerProps = {
  bgColor: string;
};

const CardContainer = styled(Box)<CardContainerProps>(({ bgColor }) => ({
  backgroundColor: bgColor,
  borderRadius: 8,
  minWidth: 200,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  cursor: 'pointer',
  alignItems: 'center',
  padding: 16
}));

const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
  borderRadius: 16,
  padding: 16,
  width: '70%'
}));
